<table>
  <tr>
    <td>
      <img *ngIf="getLockIcon()" [src]="getLockIcon()">
    </td>
  </tr>
</table>
